import React from 'react';

function Bone({ className = '' }) {
  return <div className={`animate-pulse rounded bg-gray-200 ${className}`} />;
}

/** Skeleton da listagem do blog (navegação interna). */
export function BlogListingSkeleton({ count = 8 }) {
  return (
    <div
      className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4"
      aria-busy="true"
      aria-label="Carregando posts"
    >
      {Array.from({ length: count }, (_, i) => (
        <div key={i} className="flex h-[420px] flex-col overflow-hidden rounded-lg bg-white shadow-sm">
          <Bone className="h-48 w-full rounded-none" />
          <div className="space-y-4 p-6">
            <Bone className="h-4 w-1/4" />
            <Bone className="h-6 w-3/4" />
            <Bone className="h-4 w-1/2" />
            <div className="space-y-2 pt-2">
              <Bone className="h-4 w-full" />
              <Bone className="h-4 w-full" />
              <Bone className="h-4 w-2/3" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

/** Skeleton da página de detalhe do post. */
export function BlogPostSkeleton() {
  return (
    <div
      className="min-h-screen bg-gray-50 pt-20"
      style={{ fontFamily: 'Montserrat, sans-serif' }}
      aria-busy="true"
      aria-label="Carregando post"
    >
      <div className="mx-auto max-w-7xl px-4 pb-16">
        <div className="mb-8 flex flex-wrap items-center gap-2">
          <Bone className="h-4 w-14" />
          <Bone className="h-4 w-3" />
          <Bone className="h-4 w-16" />
          <Bone className="h-4 w-3" />
          <Bone className="h-4 w-48" />
        </div>

        <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
          <div className="space-y-6 lg:col-span-2">
            <Bone className="h-10 w-full max-w-2xl" />
            <Bone className="h-4 w-40" />
            <Bone className="h-72 w-full rounded-xl md:h-96" />
            <div className="space-y-3">
              <Bone className="h-4 w-full" />
              <Bone className="h-4 w-full" />
              <Bone className="h-4 w-5/6" />
              <Bone className="h-4 w-full" />
              <Bone className="h-4 w-4/6" />
              <Bone className="h-4 w-full" />
              <Bone className="h-4 w-3/4" />
            </div>
          </div>
          <div className="space-y-4">
            <Bone className="h-40 w-full rounded-xl" />
            <Bone className="h-56 w-full rounded-xl" />
            <Bone className="h-32 w-full rounded-xl" />
          </div>
        </div>
      </div>
    </div>
  );
}
